import * as React from "react"

import { cn } from "@/lib/utils"

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "tw:flex! tw:field-sizing-content! tw:min-h-16! tw:w-full! tw:resize-none! tw:rounded-md! tw:border! tw:border-input! tw:bg-input/20! tw:px-2! tw:py-2! tw:text-sm! tw:transition-colors! tw:outline-none tw:placeholder:text-muted-foreground! tw:focus-visible:border-ring! tw:focus-visible:ring-2 tw:focus-visible:ring-ring/30 tw:disabled:cursor-not-allowed! tw:disabled:opacity-50! tw:aria-invalid:border-destructive! tw:aria-invalid:ring-2 tw:aria-invalid:ring-destructive/20 tw:md:text-xs/relaxed! tw:dark:bg-input/30! tw:dark:aria-invalid:border-destructive/50! tw:dark:aria-invalid:ring-destructive/40!",
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
